// Animated text for search custom field on mobile
function animateSearchTextMobile() {
    const animatedText = document.querySelector('[data-animated-search-text-mobile-el="text"]');
    
    if (!animatedText) {
        console.error("Animated text element not found.");
        return;
    }
    
    const words = [
        "Abiti",
        "Tute eleganti",
        "Pantaloni a zampa",
        "Jadore Accessorize",
        "Sneakers"
    ];

    let currentIndex = 0;
    const typeSpeed = parseInt(animatedText.dataset.typeSpeed) || 75;
    const deleteSpeed = parseInt(animatedText.dataset.deleteSpeed) || 25;
    const deleteDelay = parseInt(animatedText.dataset.deleteDelay) || 2000;
    const nextWordDelay = parseInt(animatedText.dataset.nextWordDelay) || 500;

    async function typeAndDeleteWord(word) {
        await typeWord(word);
        await delay(deleteDelay);
        await deleteWord(word);
        await delay(nextWordDelay);
    }

    async function typeWord(word) {
        for (let i = 0; i < word.length; i++) {
            animatedText.textContent += word[i];
            await delay(typeSpeed);
        }
    }

    async function deleteWord(word) {
        for (let i = word.length; i >= 0; i--) {
            animatedText.textContent = word.slice(0, i);
            await delay(deleteSpeed);
        }
    }

    async function cycle() {
        while (true) {
            const word = words[currentIndex];
            await typeAndDeleteWord(word);
            currentIndex = (currentIndex + 1) % words.length;
        }
    }

    function delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    cycle();
}

//Inizialize
document.addEventListener("DOMContentLoaded", animateSearchTextMobile);
